// extracted by mini-css-extract-plugin
module.exports = {"box":"Signup_box__33Kjr"};